import { ChatListItem } from '@/infrastructure/domain/chat';
import { Avatar } from 'antd';

type Props = {
  chatRoom: ChatListItem;
  isActive: boolean;
  handleOnChatItemClick: () => void;
};

const ChatItem = ({ chatRoom, isActive, handleOnChatItemClick }: Props) => {
  return (
    <div
      key={chatRoom.id}
      className={`flex items-start gap-3 p-4 hover:bg-gray-50 cursor-pointer ${isActive ? 'bg-gray-50' : ''}`}
      onClick={handleOnChatItemClick}
    >
      <Avatar src={chatRoom.profile} />
      <div className="flex-1 min-w-0">
        <div className="flex justify-between items-start">
          <p className="font-medium truncate">{chatRoom.name}</p>
        </div>
        <p className="text-sm text-muted-foreground truncate">
          {chatRoom.message}
        </p>
        <p className="text-sm text-gray-400">{chatRoom.createAtMs}</p>
      </div>
    </div>
  );
};

export default ChatItem;
